module.exports = __webpack_public_path__ + "img/service-bg2.01c914a3.png";